import { render, staticRenderFns } from "./OrganisationListAddNew.vue?vue&type=template&id=89a9caac&"
import script from "./OrganisationListAddNew.vue?vue&type=script&lang=js&"
export * from "./OrganisationListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports